import React from "react";
import Fade from "react-reveal/Fade";
import { NavLink } from "react-router-dom";
import { ProductNatureCard } from "./ProductNatureCard";
import { ProductItemsSkeleton } from "../user/ParcoursAchat/ParcoursAchat";
import { useGetProductListQuery } from "../../utils/api/product/product.api";

const SelectionProduitsNaturels: React.FC = () => {
  // Ajustez orderBy / filtres selon ce que doit afficher cette section
  // (ex: catégorie "produits naturels", derniers ajouts, etc.)
  const { data, isLoading } = useGetProductListQuery({
    page: 1,
    limit: 4,
    orderBy: "-created_at",
  });

  return (
    <section className="selection-produits-section">
      <div className="selection-produits-container">
        <div className="selection-produits-header">
          <div>
            <Fade bottom>
              <p className="selection-produits-eyebrow mb-3">
                SÉLECTION DE PRODUITS NATURELS
              </p>

              <h2 className="selection-produits-title mb-3">
                Découvrez notre sélection de produits naturels
              </h2>

              <p className="selection-produits-subtitle">
                Des plantes et produits naturels choisis avec attention pour
                leur qualité et leurs usages traditionnels.
              </p>
            </Fade>
          </div>

          <NavLink to="/produitspage" className="selection-produits-link">
            Voir tous nos produits <span aria-hidden="true">→</span>
          </NavLink>
        </div>

        <div className="selection-produits-grid">
          {isLoading && <ProductItemsSkeleton />}
          {!isLoading &&
            data?.results?.map((produit, key) => (
              <Fade bottom delay={key * 50} key={produit?.id ?? key}>
                <ProductNatureCard item={produit} />
              </Fade>
            ))}
        </div>
      </div>
    </section>
  );
};

export default SelectionProduitsNaturels;